import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d5234b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ChangeThirdPartyPhoneResourceStatistics" }
const _hoisted_2 = { class: "pagecontent" }
const _hoisted_3 = { class: "timetage" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import dayjs from 'dayjs'
import { getListData, getPageListData } from '@/service/main/system'
import { ref, onMounted, watch, computed } from 'vue'
import WatermarkCanvas from '@/components/Watermark.vue'
import PageContent from '@/components/PageContent.vue'
import { ElLoading, ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeThirdPartyPhoneResourceStatistics',
  setup(__props) {
initEmptyParam()
const store = useStore()

const pageContentRef = ref<InstanceType<typeof PageContent>>()
const selectedThirdParty = ref('')

const displayedContentTableConfig = computed(() => ({
  ...contentTableConfig,
  propList: contentTableConfig.propList.map((item) =>
    item.prop === 'repeatWithinSixMonthRate'
      ? {
          ...item,
          label:
            selectedThirdParty.value === '湖北虎符'
              ? '固定去重数'
              : '6个月内重复率'
        }
      : item
  )
}))

const formatRate = (rateStr: any, rate: any) => {
  if (rateStr !== null && rateStr !== undefined && rateStr !== '') {
    return rateStr
  }
  if (rate !== null && rate !== undefined && rate !== '') {
    return `${rate}%`
  }
  return '--'
}

const queryParam = {
  thirdParty: '',
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

// 获取第三方列表
const getThirdPartyList = async () => {
  try {
    let thirdPartyData = await getListData(
      '/main/customerChannel/queryMainThirdParty',
      {}
    )
    const thirdPartyItem = searchFormConfig.formItems.find(
      (item) => item.field === 'thirdParty'
    )
    if (thirdPartyItem) {
      thirdPartyItem.options = thirdPartyData.map((item: any) => {
        return { title: item, value: item }
      })
    }
  } catch (error) {
    console.error('获取第三方列表失败', error)
  }
}
getThirdPartyList()

const timeStr = ref('')
const changeTime = (val: any) => {
  timeStr.value = val
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const statistics = ref({
  resourcesCount: '--',
  repeatRate: '--',
  repeatWithinSixMonthRate: '--',
  deleteRate: '--',
  totalDeleteRate: '--',
  invalidNum: '--',
  thCount: '--',
  openRate: '--',
  lookRate: '--',
  dealCount: '--',
  monthConversionRate: '--',
  lastMonthConversionRate: '--',
  accConversionRate: '--'
})

// 监听 store 中的数据变化，更新统计信息
const listData = computed(() =>
  store.getters['system/pageListData']('thirdPartyPhoneResourceStatistics')
)

watch(listData, (newData) => {
  if (newData && newData.length > 0) {
    const data = newData[0] || {}
    statistics.value = {
      resourcesCount: data.resourcesCount ?? '--',
      repeatRate: data.repeatRate ?? '--',
      repeatWithinSixMonthRate: formatRate(data.repeatWithinSixMonthRateStr, data.repeatWithinSixMonthRate),
      deleteRate: data.deleteRate ?? '--',
      totalDeleteRate: data.totalDeleteRate ?? '--',
      invalidNum: data.invalidNum ?? '--',
      thCount: data.thCount ?? '--',
      openRate: data.openRate ?? '--',
      lookRate: data.lookRate ?? '--',
      dealCount: data.dealCount ?? '--',
      monthConversionRate: data.monthConversionRate ?? '--',
      lastMonthConversionRate: data.lastMonthConversionRate ?? '--',
      accConversionRate: data.accConversionRate ?? '--'
    }
  } else {
    // 清空统计数据
    statistics.value = {
      resourcesCount: '--',
      repeatRate: '--',
      repeatWithinSixMonthRate: '--',
      deleteRate: '--',
      totalDeleteRate: '--',
      invalidNum: '--',
      thCount: '--',
      openRate: '--',
      lookRate: '--',
      dealCount: '--',
      monthConversionRate: '--',
      lastMonthConversionRate: '--',
      accConversionRate: '--'
    }
  }
})

const handlePageData = async (params: any) => {
  const loading = ElLoading.service({
    lock: true,
    text: '加载中...',
    background: 'rgba(255, 255, 255, 0.7)'
  })

  try {
    const res = await getPageListData('/main/thirdPartyPhoneAccountConfig/resourceStatistics', params)
    if (res.list) {
      store.commit('system/changeThirdPartyPhoneResourceStatisticsList', res.list)
      store.commit('system/changeThirdPartyPhoneResourceStatisticsCount', Number(res.total))
    }
  } catch (error) {
    console.error('加载数据失败', error)
    ElMessage.error('加载数据失败')
  } finally {
    loading.close()
  }
}

onMounted(() => {
  // 只获取第三方列表，不调用数据接口
  getThirdPartyList()
})

// 自定义搜索逻辑：验证必填字段并调用接口
const handleSearchClickCustom = async (formdata: any) => {
  // 验证所属第三方必须有值
  if (!formdata.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return
  }

  // 验证加入时间必须有值
  if (!formdata.timeSlot || formdata.timeSlot.length !== 2) {
    ElMessage.warning('请选择加入时间')
    return
  }

  selectedThirdParty.value = formdata.thirdParty

  // 调用数据加载
  await handlePageData(formdata)
}

// 自定义重置逻辑
const handleResetClickCustom = async () => {
  selectedThirdParty.value = ''

  // 清空统计数据
  statistics.value = {
    resourcesCount: '--',
    repeatRate: '--',
    repeatWithinSixMonthRate: '--',
    deleteRate: '--',
    totalDeleteRate: '--',
    invalidNum: '--',
    thCount: '--',
    openRate: '--',
    lookRate: '--',
    dealCount: '--',
    monthConversionRate: '--',
    lastMonthConversionRate: '--',
    accConversionRate: '--'
  }

  // 使用默认参数重新加载
  await handlePageData(queryParam)
}

const handleDownBtnClick = () => {
  pageContentRef.value?.exportXlsx(store.state.system.queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WatermarkCanvas),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: handleResetClickCustom,
        onSearchBtnClick: handleSearchClickCustom
      }, null, 8, ["searchFormConfig"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(timeStr.value), 1),
        _createVNode(PageContent, {
          ref_key: "pageContentRef",
          ref: pageContentRef,
          contentTableConfig: displayedContentTableConfig.value,
          pageName: "thirdPartyPhoneResourceStatistics",
          pageUrl: "/main/thirdPartyPhoneAccountConfig/resourceStatistics",
          onSortChange: handleSortChange,
          onChangeTime: changeTime,
          onDownBtnClick: handleDownBtnClick,
          downFilename: "三方电话资源统计.xlsx"
        }, {
          repeatRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
          ]),
          repeatWithinSixMonthRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(formatRate(
                scope.row.repeatWithinSixMonthRateStr,
                scope.row.repeatWithinSixMonthRate
              )), 1)
          ]),
          deleteRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
          ]),
          totalDeleteRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.totalDeleteRate) + "%", 1)
          ]),
          openRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.openRate) + "%", 1)
          ]),
          lookRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.lookRate) + "%", 1)
          ]),
          monthConversionRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.monthConversionRate) + "%", 1)
          ]),
          lastMonthConversionRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.lastMonthConversionRate) + "%", 1)
          ]),
          accConversionRate: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.accConversionRate) + "%", 1)
          ]),
          _: 1
        }, 8, ["contentTableConfig"])
      ])
    ])
  ], 64))
}
}

})